// On an opted-in company the API hides annual-report comments from the auditor, so a comment they posted would vanish.
// Hidden until the flag answers, so it doesn't flash for an opted-in auditor.
export const isCommentActionHidden = (isRevisor: boolean, isOptedIn: boolean | undefined) =>
  isRevisor && isOptedIn !== false;
